import ShareIcon from '@mui/icons-material/Share'
import React from 'react'
import styled from 'styled-components'
import { PopoverModal } from 'sutra/components/PopoverModal/PopoverModal'
import { Tooltip } from 'sutra/components/Tooltip/Tooltip'

import { navDefaultIconColor } from 'assets/styles/variables'

interface ShareButtonViewProps {
  isCollapsed: boolean
  alias: string
  isOpen: boolean
  modalTitle: string
  onOpen: () => void
  onClose: () => void
  children: React.ReactNode
}

export const ShareButtonView = ({
  isCollapsed,
  alias,
  isOpen,
  modalTitle,
  onOpen,
  onClose,
  children,
}: ShareButtonViewProps): JSX.Element => (
  <>
    <Tooltip content={isCollapsed ? alias : ''} side="right">
      <Share onClick={onOpen} $isCollapsed={isCollapsed}>
        <IconWrapper>
          <ShareIcon style={{ fontSize: '20px' }} />
        </IconWrapper>
        {!isCollapsed && alias}
      </Share>
    </Tooltip>

    <PopoverModal
      className="share-modal"
      footer={null}
      isOpen={isOpen}
      title={modalTitle}
      onClose={onClose}
      width={720}
      content={children}
    />
  </>
)

const IconWrapper = styled.div`
  transition: color 0.2s ease;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const Share = styled.div<{ $isCollapsed?: boolean }>`
  padding: ${({ $isCollapsed }) => ($isCollapsed ? '0' : '0 12px')};
  text-decoration: none;
  display: flex;
  height: 32px;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ $isCollapsed }) =>
    $isCollapsed ? 'center' : 'flex-start'};
  cursor: pointer;
  width: ${({ $isCollapsed }) => ($isCollapsed ? '32px' : '100%')};
  border-radius: 6px;
  gap: 12px;
  background: transparent;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.25px;
  text-align: left;
  color: ${navDefaultIconColor};
  transition: color 0.2s ease;
  white-space: nowrap;
  user-select: none;

  &:hover {
    background: #5072a426;
    color: #28364f;
  }
`
